module.exports = __webpack_public_path__ + "static/media/400024_02.e682b7bd.png";